import { fetchJson } from '~/api/fetch';
import { ErrorScreen } from '~/components';
import { CommandMenuItem } from '~/providers/CommandMenuProvider/CommandMenuItem';

export const ErrorBoundary = () => {
  return (
    <>
      <ErrorScreen />

      <CommandMenuItem
        group="Error boundary"
        label="Force log out"
        onClick={async () => {
          await fetchJson('/authentication/logout', { method: 'POST' }).catch(() => null);
          window.location.reload();
        }}
        shortcut="X"
      />
    </>
  );
};
